'use strict';

import React, { PropTypes } from 'react';
import { VelocityComponent } from 'velocity-react';
import ReactDOM from 'react-dom';

require('styles/YesNo.css');

const Y0 = 37;

class YesNoComponent extends React.Component {
  constructor() {
    super();

    this.state = {
      animation: {
        x: 0, y: Y0
      },
      duration: 0
    };

    this.angle = Math.random() * 2 * Math.PI;
    this.deltas = {
      dx: Math.sin(this.angle),
      dy: Math.cos(this.angle)
    };
  }

  static propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    velocity: PropTypes.number.isRequired
  }

  translateNo() {
    let {dx, dy} = this.deltas;
    const {x, y} = this.state.animation;
    const {width} = this.dimensions;
    const [xIntercept, yIntercept] = [
      dx > 0 ? (this.props.width - width) : 0,
      dy > 0 ? (this.props.height - 2) : Y0
    ];
    const [xT, yT] = [
      (xIntercept - x) / dx,
      (yIntercept - y) / dy
    ];
    const t = xT < yT ? xT : yT;
    const [x1, y1] = [x + (dx * t), y + (dy * t)];
    dx = xT <= yT ? (-1 * dx) : dx;
    dy = yT <= xT ? (-1 * dy) : dy;
    this.deltas = {
      dx, dy
    };
    const animation = {
      x: x1, y: y1
    };
    const distance = Math.sqrt(
      Math.pow(x1 - x, 2) + Math.pow(y1 - y, 2)
    );
    const duration = (distance / this.props.velocity) * 1000;
    this.setState({
      animation,
      duration
    });
  }

  componentDidMount() {
    const no = ReactDOM.findDOMNode(this.refs.no);
    this.dimensions = no.getBoundingClientRect();
    this.translateNo();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    delete this.interval;
  }

  render() {
    const sharedProps = {
      fontFamily: 'OratorStd',
      fontSize: '30pt'
    };
    const yesProps = Object.assign(
      {},
      sharedProps,
      {
        fill: '#d3d3d3',
        x: this.props.width / 2,
        y: (this.props.height + 40) / 2,
        textAnchor: 'middle'
      });
    const noProps = Object.assign(
      {},
      sharedProps,
      {
        fillOpacity: 0,
        stroke: '#d3d3d3',
        strokeWidth: 1,
        x: 0, y: 37,
        textAnchor: 'left'
      }
    );
    const svgProps = {
      width: this.props.width,
      height: this.props.height
    };

    return (
      <svg {...svgProps}>
        <text {...yesProps}>YES</text>
        <VelocityComponent animation={this.state.animation}
                           duration={this.state.duration}
                           easing="linear"
                           complete={this.translateNo.bind(this)}>
          <text ref="no" {...noProps}>NO</text>
        </VelocityComponent>
      </svg>
    );
  }
}

YesNoComponent.displayName = 'YesNoComponent';

export default YesNoComponent;



// WEBPACK FOOTER //
// ./src/components/YesNoComponent.js